import React from 'react';
import {
  CheckoutProduct,
  GetCheckoutProductsResponse,
} from '../../../PulsoidClient';
import css from './PartnerPowerUpSection.module.css';
import {Action} from '../../../system/buttons';
import {PricingBlock} from '../../../system/PricingBlock/PricingBlock';
import {getPricingBlockLabel} from '../partnerPageHelpers';

export type PartnerPowerUpSectionProps = {
  checkoutInfo?: GetCheckoutProductsResponse;
  onCheckoutStart: (product: CheckoutProduct) => void;
  onGetStarted: () => void;

  isUserLoggedIn?: boolean;
  isUserSubscribed?: boolean;
};

export const PartnerPowerUpSection = ({
  checkoutInfo,
  onCheckoutStart,
  onGetStarted,
  isUserLoggedIn,
  isUserSubscribed,
}: PartnerPowerUpSectionProps) => {
  return (
    <div className={css.wrapper}>
      <div className={css.root}>
        <div className={css.header}>
          <h1 className={css.title}>
            <div className={`${css.titleLine} ${css.titleFirstLine}`}>
              power up
            </div>
            <div className={`${css.titleLine} ${css.titleSecondLine}`}>
              your stream with
            </div>
            <div className={css.titleLine}>
              <span className={css.pulsoidFont}>pulsoid</span>
              <div className={css.broPlanLabel}>
                <span>bro</span>
                <span>plan</span>
              </div>
            </div>
          </h1>
          <div className={css.headerDeal}>
            <h2>
              my
              <br />
              exclusive
              <br />
              deal
            </h2>
          </div>
          <img
            className={css.headerImage}
            alt="header-mascot"
            src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/partnership/partner-page-price-mascots.png"
          />
        </div>

        <div className={css.checkout}>
          {checkoutInfo?.products.map((product) => (
            <PricingBlock
              title={product.title}
              description={product.description}
              buttonLabel={getPricingBlockLabel({
                isUserLoggedIn,
                isUserSubscribed,
              })}
              discount={product.discount}
              price={product.price}
              onBuyClick={() => onCheckoutStart(product)}
              key={product.id}
            />
          ))}
        </div>

        {!isUserLoggedIn ? (
          <Action className={css.cta} square onClick={onGetStarted}>
            get started
          </Action>
        ) : null}
      </div>
    </div>
  );
};
